<template>
  <div>
    <Dialog :header="$t('sesion_titulo')" :visible='showingDialog' :modal="true" :closable="false">
      {{$t('sesion_texto')}} {{ timeLeft }}
      <template #footer>
        <Button :label="$t('sesion_continuar')" @click="closeDialog" autofocus class="btn btn-primary" />
        <Button :label="$t('sesion_cerrar')" @click="$emit('expired','button')" class="btn btn-secondary" />
      </template>
    </Dialog>
  </div>
</template>
 
<i18n>
{
  "es": {
    "sesion_titulo": "Sesión a punto de caducar",
    "sesion_texto": "Su sesión caducará en",
    "sesion_continuar": "Continuar sesión",
    "sesion_cerrar": "Cerrar sesión",
    "minutos": "minutos",
    "minuto": "minuto",
    "segundos": "segundos",
    "segundo": "segundo"
  },
  "en": {
    "sesion_titulo": "Session about to expire",
    "sesion_texto": "Your session will expire in",
    "sesion_continuar": "Continue session",
    "sesion_cerrar": "Sign off",
    "minutos": "minutes",
    "minuto": "minute",
    "segundos": "seconds",
    "segundo": "second"
  }
}
</i18n>
 
<script>
import Dialog from 'primevue/dialog';
import Button from "primevue/button";
 
export default {
  data() {
    return {
      waitSeconds: 30,
      showingDialog: false,
    };
  },
  onIdle() {
    if (!this.showingDialog) {
      this.countDown();
      this.showingDialog = true;
    }
  },
  onActive() {
  },
  methods: {
    countDown() {
      this.waitSeconds = process.env.VUE_APP_SESSION_WAIT || 30;
      let timerId = setInterval(() => {
        this.waitSeconds -= 1;
        if (!this.showingDialog) clearInterval(timerId);
 
        if (this.waitSeconds < 1) {
          clearInterval(timerId);
          // Your logout function should be over here
          console.log('logout user....');
          this.$emit('expired','time')
        }
      }, 1000);
    },
    closeDialog() {
      this.showingDialog = false;
    },
  },
  computed: {
    timeLeft: function () {
      if ( !this.waitSeconds ) return '';
      if ( this.waitSeconds === 0 ) {
        return '0 ' + this.$t('segundos');
      }
 
      var timeStr = '';
      var minutes = Math.floor( this.waitSeconds / 60 );
      if ( minutes > 0 ) {
        timeStr += minutes + ' ' + ( minutes > 1 ? this.$t('minutos') : this.$t('minuto') ) + ' ';
      }
      var seconds = this.waitSeconds % 60;
      if ( seconds > 0 ) {
        timeStr += seconds + ' ' + ( seconds > 1 ? this.$t('segundos') : this.$t('segundo') ) + ' ';
      }
      return timeStr;
    },
  },
  components: {
    Dialog,
    Button,
  }
};
</script>
 
<style lang="css" scoped>
.btn {
  font-size: 16px;
  font-weight: 500;
  padding: 13px 36px;
  margin: 8px;
  height: 48px;
  line-height: 1.25;
  letter-spacing: 0.23px;
  text-align: center;
  border-radius: 6px;
}
.btn.btn-primary {
  background: #bd2a33;
  border: solid 1px #bd2a33;
  color: #ffffff;
}
.btn.btn-primary:hover {
  background: #ca555c;
  border: solid 1px #ca555c;
  color: #ffffff;
}
.btn.btn-primary:focus {
  border: solid 1px #7bff;
  box-shadow: 0 0 0 5px rgba(0,150,248,0.15);
}
.btn.btn-secondary {
  background: #fff;
  border: solid 1px #ca555c;
  color: #ca555c;
}
.btn.btn-secondary:hover {
  background: #ffe0e2;
  border: solid 1px #ca555c;
  color: #ca555c;
}
.btn.btn-secondary:focus {
  border: solid 1px #7bff;
  box-shadow: 0 0 0 5px rgba(0,150,248,0.15);
}
::v-deep .p-dialog .p-dialog-footer button + button {
  margin: 0 0 0 16px;
}
::v-deep .p-dialog .p-dialog-footer {
  padding-top: 19px;
  border-top: solid 2px #c8cacc;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
::v-deep .p-dialog .p-dialog-header {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
</style>